export function initSelect(){
    const selects = document.querySelectorAll<HTMLElement>('.select');

    selects.forEach(select => {
        const button = select.querySelector<HTMLButtonElement>('.select-default');
        const text = select.querySelector<HTMLElement>('.select-default__text');
        const items = select.querySelectorAll<HTMLButtonElement>('.select-item');

        if (!button || !text) return;

        // Открытие / закрытие по кнопке
        button.addEventListener('click', (e) => {
            e.stopPropagation();
            select.classList.toggle('show');
        });

        // Клик по пункту
        items.forEach(item => {
            item.addEventListener('click', (e) => {
                e.stopPropagation();

                // текст
                text.textContent = item.textContent?.trim() || '';

                // active
                items.forEach(i => i.classList.remove('active'));
                item.classList.add('active');

                // закрыть
                select.classList.remove('show');
            });
        });
    });

    // Клик вне селекта
    document.addEventListener('click', (e) => {
        const target = e.target as HTMLElement;

        document.querySelectorAll<HTMLElement>('.select.show').forEach(select => {
            if (!select.contains(target)) {
                select.classList.remove('show');
            }
        });
    });
}